import { render } from "./AddressMapCard.vue?vue&type=template&id=521cb159&scoped=true"
import script from "./AddressMapCard.vue?vue&type=script&lang=js"
export * from "./AddressMapCard.vue?vue&type=script&lang=js"

import "./AddressMapCard.vue?vue&type=style&index=0&id=521cb159&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-521cb159"]])

export default __exports__